module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n   " + _vm._s(_vm.isEdit ? 'Update Link' : 'Create Link') + "\n  ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/link-list"
    }
  }, [_vm._v("Link Management")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.isEdit ? 'Update' : 'Create'))])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12"
  }, [(!_vm.isEdit) ? _c('ul', {
    staticClass: "nav nav-tabs link-tabs"
  }, [_c('li', {
    class: {
      active: _vm.activeTab === 'shortlink'
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activeTab = 'shortlink'
      }
    }
  }, [_vm._v("Nivi Short Link")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab === 'messaging'
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activeTab = 'messaging'
      }
    }
  }, [_vm._v("Messaging Link Generator")])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'shortlink' || _vm.isEdit) ? _c('div', {
    staticClass: "tab-content-area"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addOrUpdateOrDeleteLink.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Link Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.name),
      expression: "gRowObj.name"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.name.required
    },
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Insert Name"
    },
    domProps: {
      "value": (_vm.gRowObj.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.name.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter link name.")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "long_url"
    }
  }, [_vm._v("Destination")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.long_url),
      expression: "gRowObj.long_url"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.long_url.required
    },
    attrs: {
      "type": "text",
      "id": "long_url",
      "placeholder": "Insert Long Url"
    },
    domProps: {
      "value": (_vm.gRowObj.long_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "long_url", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.long_url.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter url.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.long_url.url) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter valid long url.")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "Client"
    }
  }, [_vm._v("Customer")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.client_id.required
    },
    attrs: {
      "id": "Client"
    },
    model: {
      value: (_vm.gRowObj.client_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "client_id", $$v)
      },
      expression: "gRowObj.client_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Option--")]), _vm._v(" "), _vm._l((_vm.clientList), function(data) {
    return _c('option', {
      key: data.id,
      domProps: {
        "selected": data.id === _vm.gRowObj.client_id,
        "value": data.id
      }
    }, [_vm._v(_vm._s(data.name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.client_id.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose an client.")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "Topic"
    }
  }, [_vm._v("Topic")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "id": "Topic"
    },
    model: {
      value: (_vm.gRowObj.topic_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "topic_id", $$v)
      },
      expression: "gRowObj.topic_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Option--")]), _vm._v(" "), _vm._l((_vm.topicList), function(data) {
    return _c('option', {
      key: data.id,
      domProps: {
        "selected": data.id === _vm.gRowObj.topic_id,
        "value": data.id
      }
    }, [_vm._v(_vm._s(data.display_name))])
  })], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.link_type),
      expression: "gRowObj.link_type"
    }],
    attrs: {
      "type": "radio",
      "value": "auto",
      "name": "auto"
    },
    domProps: {
      "checked": _vm._q(_vm.gRowObj.link_type, "auto")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.gRowObj, "link_type", "auto")
      }, function($event) {
        return _vm.changeLinkType('auto')
      }]
    }
  }), _vm._v("Generate URL\n                        ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.link_type),
      expression: "gRowObj.link_type"
    }],
    attrs: {
      "type": "radio",
      "value": "manual",
      "name": "manual"
    },
    domProps: {
      "checked": _vm._q(_vm.gRowObj.link_type, "manual")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.gRowObj, "link_type", "manual")
      }, function($event) {
        return _vm.changeLinkType('manual')
      }]
    }
  }), _vm._v("I want to create a vanity URL\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [(_vm.gRowObj.link_type === 'auto') ? _c('div', {
    staticClass: "form-group form-inline"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v(_vm._s(_vm.gRowObj.domain_name) + _vm._s(_vm.gRowObj.code))]), _vm._v("\n                              "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "disabled": !(_vm.gRowObj.code && _vm.gRowObj.code.trim())
    },
    on: {
      "click": _vm.checkLinkAvailability
    }
  }, [_vm._v("Check Link Value")]), _vm._v("\n                             "), _c('input', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button",
      "value": "Copy Link"
    },
    on: {
      "click": function($event) {
        return _vm.copyLink()
      }
    }
  }), _vm._v("\n                             "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button",
      "disabled": !(_vm.gRowObj.code && _vm.gRowObj.code.trim())
    },
    on: {
      "click": _vm.toggleShortLinkQr
    }
  }, [_c('i', {
    staticClass: "fa fa-qrcode"
  }), _vm._v(" " + _vm._s(_vm.showShortLinkQr ? 'Hide' : 'Show') + " QR")])]) : _vm._e(), _vm._v(" "), (_vm.gRowObj.link_type === 'manual') ? _c('div', {
    staticClass: "form-group form-inline"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v(_vm._s(_vm.gRowObj.domain_name))]), _vm._v("  \n                            "), _c('span', {
    staticStyle: {
      "display": "inline-grid",
      "text-align": "end"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.code),
      expression: "gRowObj.code"
    }],
    staticClass: "form-control required",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.code.required
    },
    attrs: {
      "type": "text",
      "id": "code",
      "placeholder": "Insert text"
    },
    domProps: {
      "value": (_vm.gRowObj.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "code", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.code.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter text.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.code.codeUrlValidationRegex) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter a valid URL")]) : _vm._e()]), _vm._v("\n                             "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "disabled": !(_vm.gRowObj.code && _vm.gRowObj.code.trim())
    },
    on: {
      "click": _vm.checkLinkAvailability
    }
  }, [_vm._v("Check Link Value")]), _vm._v("\n                             "), _c('input', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button",
      "value": "Copy Link"
    },
    on: {
      "click": function($event) {
        return _vm.copyLink()
      }
    }
  }), _vm._v("\n                             "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button",
      "disabled": !(_vm.gRowObj.code && _vm.gRowObj.code.trim())
    },
    on: {
      "click": _vm.toggleShortLinkQr
    }
  }, [_c('i', {
    staticClass: "fa fa-qrcode"
  }), _vm._v(" " + _vm._s(_vm.showShortLinkQr ? 'Hide' : 'Show') + " QR")])]) : _vm._e(), _vm._v(" "), (_vm.showShortLinkQr) ? _c('div', {
    staticClass: "shortlink-qr-section"
  }, [_c('div', {
    staticClass: "shortlink-qr-container"
  }, [_c('div', {
    staticClass: "shortlink-qr-header"
  }, [_vm._v("QR Code Preview")]), _vm._v(" "), (_vm.shortLinkQrPreview) ? _c('img', {
    staticClass: "shortlink-qr-image",
    attrs: {
      "src": _vm.shortLinkQrPreview,
      "alt": "QR Code"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "shortlink-qr-link"
  }, [_vm._v(_vm._s(_vm.gRowObj.domain_name) + _vm._s(_vm.gRowObj.code))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.downloadShortLinkQr
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download QR (1024 x 1024)\n                              ")])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "action-button"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "submit",
      "value": "Submit"
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'messaging' && !_vm.isEdit) ? _c('div', {
    staticClass: "tab-content-area"
  }, [_c('MessagingLinkGenerator')], 1) : _vm._e()])])])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Link Configuration")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6ef457f4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/link-management/addOrUpdateLink.vue
// module id = ohGf
// module chunks = 1